module.exports = __webpack_public_path__ + "static/media/icon-lizard.7d2e0b18.svg";